import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import Usuario from "../supabase/Usuario";
import logo from "../Login/logo.png";
import {useAuth} from "../../context/AuthContext";

export default function ProfileEdit() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [okMsg, setOkMsg] = useState('');
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [placeholder, setPlaceholder] = useState();

    useEffect(() => {
        async function fetchData(){
            const data = await Usuario.getUsuario(user.numDocumento)
            if (data) {
                setPlaceholder(data)
            }

            setForm({
                nombre: data[0].nombre || '',
                correo: data[0].correo || '',
                telefono: data[0].numtelefono || '',
                usuario: data[0].usuario || '',
                direccion: data[0].direccion || '',
                descripcion: data[0].descripcion || '',
            });
        }
        fetchData()
    }, [user]);

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const [form, setForm] = useState({
        nombre: '',
        correo: '',
        telefono: '',
        usuario: '',
        direccion: '',
        descripcion: '',
        contrasenna: ''
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setOkMsg('');
        setLoading(true);
        try {
            console.log("update call")
            const ok = await Usuario.update(
                user.numDocumento,
                form.nombre,
                form.usuario,
                form.correo,
                form.contrasenna,
                form.telefono,
                form.direccion,
                form.descripcion
            );
            if (ok) {
                setOkMsg('Cuenta actualizada con éxito.');
                setTimeout(() => navigate('/profile'), 800);
            } else {
                setError('No se pudo actualizar la cuenta. Verifica los datos.');
            }
        } catch (err) {
            setError('Ocurrió un error actualizar la cuenta.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="app-container">
            <div className="profile-edit-page">
                <header className="topbar">
                    <div className="brand">
                        <img src={logo} alt="logo" className="brand-logo" />
                        <nav className="nav">
                            <button className="nav-link" onClick={() => navigate('/home')}>Inicio</button>
                            <button className="nav-link active" onClick={() => navigate('/profile')}>Mi nido</button>
                        </nav>
                        <button className="logout-btn" onClick={handleLogout} title="Cerrar sesión">↪</button>
                    </div>
                    <title>ReANIDArt - Editar perfil</title>
                </header>

                <main className="profile-edit-main">
                    <form className="profile-edit-card" onSubmit={handleSubmit}>
                        <label className="field">
                            <span>Nombre completo</span>
                            <input name="nombre" value={form.nombre} onChange={onChange} required/>
                        </label>

                        <label className="field">
                            <span>Nombre de usuario</span>
                            <input name="usuario" value={form.usuario} onChange={onChange} required/>
                        </label>

                        <label className="field">
                            <span>Dirección de correo</span>
                            <input type="email" name="correo" value={form.correo} onChange={onChange} required/>
                        </label>

                        <label className="field">
                            <span>Número de teléfono</span>
                            <input name="telefono" value={form.telefono} onChange={onChange} />
                        </label>

                        <label className="field">
                            <span>Mi historia</span>
                            <input name="descripcion" value={form.descripcion} onChange={onChange} required/>
                        </label>

                        {error && <div className="error" role="alert">{error}</div>}
                        {okMsg && <div className="ok" role="status">{okMsg}</div>}

                        <div className="actions row">
                            <button type="button" className="btn" onClick={() => navigate('/profile')}>Cancelar</button>
                            <button type="submit" className="btn primary"
                                    disabled={loading}>{loading ? 'Actualizando...' : 'Actualizar'}</button>
                        </div>
                    </form>
                </main>
            </div>
        </div>
    );
}